import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useT } from '@/i18n/react';
import { isPlayAnalyticsSurface, isPlayOverlay, PLAY_CONSENT_KEY, PLAY_CONSENT_OPEN_EVENT, readPlayConsent, savePlayConsent, trackPlayPage } from '@/lib/playWebAnalytics';
import './play-analytics-consent.css';

export function PlayAnalyticsConsent() {
  const { pathname, search } = useLocation();
  const [consent, setConsent] = useState(() => readPlayConsent()), [open, setOpen] = useState(() => !readPlayConsent());
  const enabled = isPlayAnalyticsSurface() && !isPlayOverlay(search);
  useEffect(() => { if (enabled) trackPlayPage(pathname); }, [enabled, pathname, consent]);
  useEffect(() => {
    if (!enabled) return;
    const sync = (event: StorageEvent) => { if (event.key !== PLAY_CONSENT_KEY && event.key !== null) return; setConsent(readPlayConsent()); trackPlayPage(pathname); };
    window.addEventListener('storage', sync); return () => window.removeEventListener('storage', sync);
  }, [enabled, pathname]);
  // Reopened from Settings → Cookie settings; there is no floating button.
  useEffect(() => {
    if (!enabled) return;
    const reopen = () => setOpen(true);
    window.addEventListener(PLAY_CONSENT_OPEN_EVENT, reopen); return () => window.removeEventListener(PLAY_CONSENT_OPEN_EVENT, reopen);
  }, [enabled]);
  if (!enabled || !open || pathname.startsWith('/admin')) return null;
  const save = (analytics: boolean) => { setConsent(savePlayConsent(analytics)); setOpen(false); };
  return <PlayConsentPanel onSave={save}/>;
}

export function PlayConsentPanel({ onSave }: { onSave: (analytics: boolean) => void }) {
  const t = useT().playAnalytics;
  return <div className="play-analytics-consent">
    <aside className="play-consent-panel" aria-labelledby="play-consent-title"><h2 id="play-consent-title">{t.title}</h2><p>{t.description}</p><p>{t.retention}</p><div className="play-consent-actions"><button type="button" onClick={() => onSave(false)}>{t.necessary}</button><button type="button" onClick={() => onSave(true)}>{t.accept}</button></div></aside>
  </div>;
}
